import React, { useState, useEffect } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import {
  CreateMarketingStudent,
  GetMarketingSchool,
} from "../../../api/MarketinService";
import {
  BlockFetch,
  DistrictFetch,
  StateFetch,
} from "../../../api/LocationService";
import Swal from "sweetalert2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getSessions } from "../../../api/SessionsService";
import { ToastMain, SweetAlertShow, LoadingDiv } from "../../master/Master";
import { courseList } from "../../../api/Courses";
import MarketingHeader from "./MarketingHeader";

const StudentForm = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [school, setSchool] = useState([]);
  const location = useLocation();
  const [HostelId, setHostelId] = useState("");
  const [allStates, setAllStates] = useState([]);
  const [allDistricts, setAllDistricts] = useState([]);
  const [allBlock, setAllBlock] = useState([]);
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [subjects, setSubjects] = useState("");
  const [session, setSession] = useState("");
  const [data, setData] = useState("");
  const [source, setSource] = useState([]);
  const [courses, setCourses] = useState([]);
  const [address, setAddress] = useState(false);
  const [permission, setPermission] = useState(false);
  const [selectedSession, setSelectedSession] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const source_id = queryParams.get("sourse_id");
  const source_name = queryParams.get("sourse_name");

  const handleToggle = () => {
    setAddress((prev) => !prev);
  };

  const handlePermissionToggle = () => {
    setPermission((prev) => !prev);
  };

  const courseFetch = async () => {
    setLoading(true);

    try {
      const response = await courseList();

      if (response.data.status) {
        setCourses(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
  }, []);

  const getSource = async () => {
    try {
      const response = await GetMarketingSchool();

      if (response?.data) {
        setSource(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };

  const createStudent = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(e.target);

      formData.append("session_id", selectedSession);

      if (source_id) {
        formData.append("source_id", source_id);
      }

      const response = await CreateMarketingStudent(formData);

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "created successfully!",
        }).then(() => {
          e.target.reset();
        });
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.message ??
          error?.response?.data?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getSession = async () => {
    try {
      const response = await getSessions();

      if (response.data.status) {
        const activeSession = response?.data?.data?.find(
          (s) => s?.status == "1",
        );

        setSelectedSession(activeSession?.id);
        setSession(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    }
  };

  const getState = async () => {
    setLoading(true);

    try {
      const response = await StateFetch();

      if (response.data) {
        setAllStates(response?.data?.states);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getdistrict = async (state) => {
    setLoading(true);

    try {
      const response = await DistrictFetch(state);

      if (response.data) {
        setAllDistricts(response?.data?.districts);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getblock = async (district) => {
    setLoading(true);

    try {
      const response = await BlockFetch(district);

      if (response?.data) {
        setAllBlock(response?.data?.blocks);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchSchool = async () => {
    setLoading(true);

    try {
      const response = await GetMarketingSchool();

      if (response.data) {
        setSchool(response?.data);
      } else {
        setError("Failed to fetch courses.");
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (err) {
      SweetAlertShow("error", "Error", error?.data?.message ?? err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getState();
    getSession();
    fetchSchool();
    getSource();
  }, []);

  const navigate = useNavigate();

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                <div className="row g-4">
                  {/* =====================================================
                      MARKETING HEADER
                  ====================================================== */}
                  <div className="col-12">
                    <MarketingHeader />
                  </div>

                  {/* =====================================================
                      PAGE HEADER
                  ====================================================== */}
                  <div className="col-12">
                    <div className="card border-0 shadow-sm overflow-hidden">
                      <div className="card-header bg-transparent border-bottom px-4 py-3">
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                          {/* Left Header */}
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="rounded-3 bg-primary text-white d-flex align-items-center justify-content-center"
                              style={{
                                width: "48px",
                                height: "48px",
                                minWidth: "48px",
                              }}
                            >
                              <i className="ri-user-add-line fs-4"></i>
                            </div>

                            <div>
                              <h4 className="mb-1 fw-bold">
                                Student Add
                                {source_id && (
                                  <span className="text-danger text-capitalize ms-2">
                                    In ({source_name})
                                  </span>
                                )}
                              </h4>

                              <p className="mb-0 text-muted small">
                                Add a new student to your marketing records
                              </p>
                            </div>
                          </div>

                          {/* Back Button */}
                          <Link
                            to="/marketing/all-students"
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                          >
                            <i className="ri-arrow-left-line"></i>
                            <span>Back to Students</span>
                          </Link>
                        </div>
                      </div>

                      {/* =====================================================
                          FORM
                      ====================================================== */}
                      <div className="card-body p-4 p-lg-5">
                        <form onSubmit={createStudent}>
                          {/* =================================================
                              PERSONAL INFORMATION
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div className="text-primary">
                                <i className="ri-user-line fs-5"></i>
                              </div>

                              <div>
                                <h6 className="fw-bold mb-0">
                                  Personal Information
                                </h6>

                                <small className="text-muted">
                                  Enter the student's basic details
                                </small>
                              </div>
                            </div>

                            <div className="border rounded-3 p-3 p-lg-4">
                              <div className="row g-4">
                                {/* Student Name */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control text-capitalize input-capitalize"
                                      type="text"
                                      name="name"
                                      placeholder="Student Name"
                                    />

                                    <label>
                                      <i className="ri-user-line me-1"></i>
                                      Student Name
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.name ?? ""}
                                  </span>
                                </div>

                                {/* Father Name */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control text-capitalize input-uppercase"
                                      type="text"
                                      name="fathers_name"
                                      placeholder="Father Name"
                                    />

                                    <label>
                                      <i className="ri-user-line me-1"></i>
                                      Father Name
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.fathers_name ?? ""}
                                  </span>
                                </div>

                                {/* Mobile */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name="mobile"
                                      placeholder="Mobile No"
                                      minLength={10}
                                      maxLength={10}
                                    />

                                    <label>
                                      <i className="ri-phone-line me-1"></i>
                                      Mobile No
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.mobile ?? ""}
                                  </span>
                                </div>

                                {/* Source */}
                                {!source_id && (
                                  <div className="col-md-6">
                                    <div className="form-floating form-floating-outline">
                                      <select
                                        className="form-select text-capitalize"
                                        name="source_id"
                                      >
                                        <option value="">Select Source</option>

                                        {source?.data?.map((sch, index) => (
                                          <option
                                            key={sch.id}
                                            value={sch.id}
                                            selected={
                                              source_id == sch?.id && true
                                            }
                                          >
                                            {sch.source_name}
                                          </option>
                                        ))}
                                      </select>

                                      <label>
                                        <i className="ri-megaphone-line me-1"></i>
                                        Source Name{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>

                                    <span className="text-danger small">
                                      {error?.source_id ?? ""}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* =================================================
                              COURSE & EDUCATION
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div className="text-primary">
                                <i className="ri-book-open-line fs-5"></i>
                              </div>

                              <div>
                                <h6 className="fw-bold mb-0">
                                  Academic Information
                                </h6>

                                <small className="text-muted">
                                  Select course and latest education level
                                </small>
                              </div>
                            </div>

                            <div className="border rounded-3 p-3 p-lg-4">
                              <div className="row g-4">
                                {/* Course */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select text-capitalize"
                                      id="course_id"
                                      name="course_id"
                                      required
                                    >
                                      <option value="">Select Course</option>

                                      {courses.map((course) => (
                                        <option
                                          key={course.id}
                                          value={course.id}
                                        >
                                          {course.title}
                                        </option>
                                      ))}
                                    </select>

                                    <label htmlFor="course_id">
                                      <i className="ri-bookmark-line me-1"></i>
                                      Select Course{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.course_id ?? ""}
                                  </span>
                                </div>

                                {/* Education */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="edu_level"
                                    >
                                      <option selected disabled>
                                        Select Education
                                      </option>

                                      <option value="9th">9th</option>
                                      <option value="10th">10th</option>
                                      <option value="11th">11th</option>
                                      <option value="12th">12th</option>
                                    </select>

                                    <label>
                                      <i className="ri-graduation-cap-line me-1"></i>
                                      Last Education
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.edu_level ?? ""}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* =================================================
                              CONTACT & ADDRESS
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <div className="text-primary">
                                <i className="ri-map-pin-line fs-5"></i>
                              </div>

                              <div>
                                <h6 className="fw-bold mb-0">
                                  Contact & Address
                                </h6>

                                <small className="text-muted">
                                  Enter alternate contact and location details
                                </small>
                              </div>
                            </div>

                            <div className="border rounded-3 p-3 p-lg-4">
                              <div className="row g-4">
                                {/* Alternate Number */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name="alternate_no"
                                      placeholder="Alternate No"
                                      minLength={10}
                                      maxLength={10}
                                    />

                                    <label>
                                      <i className="ri-phone-line me-1"></i>
                                      Alternate No
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.alternate_no ?? ""}
                                  </span>
                                </div>

                                {/* Village */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control text-capitalize input-uppercase"
                                      type="text"
                                      name="village"
                                      placeholder="Village"
                                    />

                                    <label>
                                      <i className="ri-map-pin-2-line me-1"></i>
                                      Village
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.village ?? ""}
                                  </span>
                                </div>

                                {/* State */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select text-capitalize"
                                      name="state"
                                      onChange={(e) =>
                                        getdistrict(e.target.value)
                                      }
                                    >
                                      <option value="">Select State</option>

                                      {allStates?.map((state) => (
                                        <option
                                          key={state.id}
                                          value={state.name}
                                        >
                                          {state.name}
                                        </option>
                                      ))}
                                    </select>

                                    <label>
                                      <i className="ri-map-pin-line me-1"></i>
                                      State
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.state ?? ""}
                                  </span>
                                </div>

                                {/* District */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select text-capitalize"
                                      name="district"
                                      onChange={(e) => getblock(e.target.value)}
                                    >
                                      <option value="">Select District</option>

                                      {allDistricts?.map((district) => (
                                        <option
                                          key={district.id}
                                          value={district.name}
                                        >
                                          {district.name}
                                        </option>
                                      ))}
                                    </select>

                                    <label>
                                      <i className="ri-map-pin-line me-1"></i>
                                      District
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.district ?? ""}
                                  </span>
                                </div>

                                {/* Pincode */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name="pincode"
                                      placeholder="Pincode"
                                    />

                                    <label>
                                      <i className="ri-map-pin-2-line me-1"></i>
                                      Pincode
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.pincode ?? ""}
                                  </span>
                                </div>

                                {/* Note */}
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <textarea
                                      className="form-control text-capitalize input-uppercase"
                                      name="description"
                                      placeholder="Note"
                                      rows="3"
                                      style={{ height: "100px" }}
                                    ></textarea>

                                    <label>
                                      <i className="ri-sticky-note-line me-1"></i>
                                      Note
                                    </label>
                                  </div>

                                  <span className="text-danger small">
                                    {error?.description ?? ""}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* =================================================
                              FORM FOOTER
                          ================================================== */}
                          <div className="border-top pt-4 mt-4">
                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                              <div className="text-muted small">
                                <i className="ri-information-line me-1"></i>
                                Please verify the student information before
                                submitting.
                              </div>

                              <div className="d-flex gap-2">
                                <Link
                                  to="/marketing/all-students"
                                  className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
                                >
                                  <i className="ri-close-line"></i>
                                  Cancel
                                </Link>

                                <button
                                  type="submit"
                                  className="btn btn-primary px-4 d-inline-flex align-items-center justify-content-center gap-2"
                                  disabled={loading}
                                >
                                  {loading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span>Submitting...</span>
                                    </>
                                  ) : (
                                    <>
                                      <i className="ri-save-line"></i>
                                      <span>Submit Student</span>
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <Footer />

                  <div className="content-backdrop fade"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
    </>
  );
};

export default StudentForm;
